"use strict";

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signMultiSignatureTransactionWithPrivateKey = exports.signTransactionWithPrivateKey = exports.signMultiSignatureTransaction = exports.signTransaction = exports.getBytes = exports.getSigningBytes = void 0;

var lisk_codec_1 = require("@liskhq/lisk-codec");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var validate_1 = require("./validate");

var schema_1 = require("./schema");

var getSigningBytes = function getSigningBytes(assetSchema, transactionObject) {
  var validationErrors = validate_1.validateTransaction(assetSchema, transactionObject);

  if (validationErrors) {
    throw validationErrors;
  }

  if (typeof transactionObject.asset !== 'object' || transactionObject.asset === null) {
    throw new Error('Asset must be of type object and not null');
  }

  var assetBytes = lisk_codec_1.codec.encode(assetSchema, transactionObject.asset);
  var transactionBytes = lisk_codec_1.codec.encode(schema_1.baseTransactionSchema, _objectSpread({}, transactionObject, {
    asset: assetBytes,
    signatures: []
  }));
  return transactionBytes;
};

exports.getSigningBytes = getSigningBytes;

var getBytes = function getBytes(assetSchema, transactionObject) {
  if (typeof transactionObject.asset !== 'object' || transactionObject.asset === null) {
    throw new Error('Asset must be of type object and not null');
  }

  var assetBytes = lisk_codec_1.codec.encode(assetSchema, transactionObject.asset);
  var transactionBytes = lisk_codec_1.codec.encode(schema_1.baseTransactionSchema, _objectSpread({}, transactionObject, {
    asset: assetBytes
  }));
  return transactionBytes;
};

exports.getBytes = getBytes;

var signTransaction = function signTransaction(assetSchema, transactionObject, networkIdentifier, passphrase) {
  if (!networkIdentifier.length) {
    throw new Error('Network identifier is required to sign a transaction');
  }

  if (!passphrase) {
    throw new Error('Passphrase is required to sign a transaction');
  }

  var validationErrors = validate_1.validateTransaction(assetSchema, transactionObject);

  if (validationErrors) {
    throw validationErrors;
  }

  var _lisk_cryptography_1$ = lisk_cryptography_1.getAddressAndPublicKeyFromPassphrase(passphrase),
      publicKey = _lisk_cryptography_1$.publicKey;

  if (!Buffer.isBuffer(transactionObject.senderPublicKey) || !transactionObject.senderPublicKey.equals(publicKey)) {
    throw new Error('Transaction senderPublicKey does not match public key from passphrase');
  }

  var transactionWithNetworkIdentifierBytes = Buffer.concat([networkIdentifier, exports.getSigningBytes(assetSchema, transactionObject)]);
  var signature = lisk_cryptography_1.signData(transactionWithNetworkIdentifierBytes, passphrase);
  transactionObject.signatures = [signature];
  return _objectSpread({}, transactionObject, {
    id: lisk_cryptography_1.hash(exports.getBytes(assetSchema, transactionObject))
  });
};

exports.signTransaction = signTransaction;

var sanitizeSignaturesArray = function sanitizeSignaturesArray(transactionObject, keys, includeSenderSignature) {
  var numberOfSignatures = (includeSenderSignature ? 1 : 0) + keys.mandatoryKeys.length + keys.optionalKeys.length;

  for (var i = 0; i < numberOfSignatures; i += 1) {
    if (Array.isArray(transactionObject.signatures) && transactionObject.signatures[i] === undefined) {
      transactionObject.signatures[i] = Buffer.alloc(0);
    }
  }
};

var signMultiSignatureTransaction = function signMultiSignatureTransaction(assetSchema, transactionObject, networkIdentifier, passphrase, keys) {
  var includeSenderSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (!networkIdentifier.length) {
    throw new Error('Network identifier is required to sign a transaction');
  }

  if (!passphrase) {
    throw new Error('Passphrase is required to sign a transaction');
  }

  if (!Array.isArray(transactionObject.signatures)) {
    throw new Error('Signatures must be of type array');
  }

  var validationErrors = validate_1.validateTransaction(assetSchema, transactionObject);

  if (validationErrors) {
    throw validationErrors;
  }

  keys.mandatoryKeys.sort(function (publicKeyA, publicKeyB) {
    return publicKeyA.compare(publicKeyB);
  });
  keys.optionalKeys.sort(function (publicKeyA, publicKeyB) {
    return publicKeyA.compare(publicKeyB);
  });

  var _lisk_cryptography_1$2 = lisk_cryptography_1.getAddressAndPublicKeyFromPassphrase(passphrase),
      publicKey = _lisk_cryptography_1$2.publicKey;

  var transactionWithNetworkIdentifierBytes = Buffer.concat([networkIdentifier, exports.getSigningBytes(assetSchema, transactionObject)]);
  var signature = lisk_cryptography_1.signData(transactionWithNetworkIdentifierBytes, passphrase);

  if (includeSenderSignature && Buffer.isBuffer(transactionObject.senderPublicKey) && publicKey.equals(transactionObject.senderPublicKey)) {
    transactionObject.signatures[0] = signature;
  }

  var mandatoryKeyIndex = keys.mandatoryKeys.findIndex(function (aPublicKey) {
    return aPublicKey.equals(publicKey);
  });
  var optionalKeyIndex = keys.optionalKeys.findIndex(function (aPublicKey) {
    return aPublicKey.equals(publicKey);
  });

  if (mandatoryKeyIndex !== -1) {
    var signatureOffset = includeSenderSignature ? 1 : 0;
    transactionObject.signatures[mandatoryKeyIndex + signatureOffset] = signature;
  }

  if (optionalKeyIndex !== -1) {
    var _signatureOffset = includeSenderSignature ? 1 : 0;

    transactionObject.signatures[keys.mandatoryKeys.length + optionalKeyIndex + _signatureOffset] = signature;
  }

  sanitizeSignaturesArray(transactionObject, keys, includeSenderSignature);
  return _objectSpread({}, transactionObject, {
    id: lisk_cryptography_1.hash(exports.getBytes(assetSchema, transactionObject))
  });
};

exports.signMultiSignatureTransaction = signMultiSignatureTransaction;

var signTransactionWithPrivateKey = function signTransactionWithPrivateKey(assetSchema, transactionObject, networkIdentifier, privateKey) {
  if (!networkIdentifier.length) {
    throw new Error('Network identifier is required to sign a transaction');
  }

  if (!privateKey.length || privateKey.length !== 64) {
    throw new Error('Private key must be 64 bytes');
  }

  var validationErrors = validate_1.validateTransaction(assetSchema, transactionObject);

  if (validationErrors) {
    throw validationErrors;
  }

  var transactionWithNetworkIdentifierBytes = Buffer.concat([networkIdentifier, exports.getSigningBytes(assetSchema, transactionObject)]);
  var signature = lisk_cryptography_1.signDataWithPrivateKey(transactionWithNetworkIdentifierBytes, privateKey);
  transactionObject.signatures = [signature];
  return _objectSpread({}, transactionObject, {
    id: lisk_cryptography_1.hash(exports.getBytes(assetSchema, transactionObject))
  });
};

exports.signTransactionWithPrivateKey = signTransactionWithPrivateKey;

var signMultiSignatureTransactionWithPrivateKey = function signMultiSignatureTransactionWithPrivateKey(assetSchema, transactionObject, networkIdentifier, privateKey, keys) {
  var includeSenderSignature = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (!networkIdentifier.length) {
    throw new Error('Network identifier is required to sign a transaction');
  }

  if (!privateKey.length || privateKey.length !== 64) {
    throw new Error('Private key must be 64 bytes');
  }

  if (!Array.isArray(transactionObject.signatures)) {
    throw new Error('Signatures must be of type array');
  }

  var validationErrors = validate_1.validateTransaction(assetSchema, transactionObject);

  if (validationErrors) {
    throw validationErrors;
  }

  var publicKey = transactionObject.senderPublicKey;
  keys.mandatoryKeys.sort(function (publicKeyA, publicKeyB) {
    return publicKeyA.compare(publicKeyB);
  });
  keys.optionalKeys.sort(function (publicKeyA, publicKeyB) {
    return publicKeyA.compare(publicKeyB);
  });
  var transactionWithNetworkIdentifierBytes = Buffer.concat([networkIdentifier, exports.getSigningBytes(assetSchema, transactionObject)]);
  var signature = lisk_cryptography_1.signDataWithPrivateKey(transactionWithNetworkIdentifierBytes, privateKey);

  if (includeSenderSignature && Buffer.isBuffer(transactionObject.senderPublicKey)) {
    transactionObject.signatures[0] = signature;
  }

  var mandatoryKeyIndex = keys.mandatoryKeys.findIndex(function (aPublicKey) {
    return aPublicKey.equals(publicKey);
  });
  var optionalKeyIndex = keys.optionalKeys.findIndex(function (aPublicKey) {
    return aPublicKey.equals(publicKey);
  });

  if (mandatoryKeyIndex !== -1) {
    var signatureOffset = includeSenderSignature ? 1 : 0;
    transactionObject.signatures[mandatoryKeyIndex + signatureOffset] = signature;
  }

  if (optionalKeyIndex !== -1) {
    var _signatureOffset2 = includeSenderSignature ? 1 : 0;

    transactionObject.signatures[keys.mandatoryKeys.length + optionalKeyIndex + _signatureOffset2] = signature;
  }

  sanitizeSignaturesArray(transactionObject, keys, includeSenderSignature);
  return _objectSpread({}, transactionObject, {
    id: lisk_cryptography_1.hash(exports.getBytes(assetSchema, transactionObject))
  });
};

exports.signMultiSignatureTransactionWithPrivateKey = signMultiSignatureTransactionWithPrivateKey;